import { render, staticRenderFns } from "./loginView.vue?vue&type=template&id=4dc056e7&scoped=true"
import script from "./loginView.vue?vue&type=script&lang=js"
export * from "./loginView.vue?vue&type=script&lang=js"
import style0 from "./loginView.vue?vue&type=style&index=0&id=4dc056e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc056e7",
  null
  
)

export default component.exports